<script setup lang="ts">
import { PriceGuaranteeSunBanner } from '@apps/main/new-desktop/modules/priceGuarantee';
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import HotelAmenitiesSectionLoader from './HotelAmenitiesSectionLoader.vue';
import HotelDescriptionOpeningParagraphSectionLoader from './HotelDescriptionOpeningParagraphSectionLoader.vue';
import HotelDetailsHeaderLoader from './HotelDetailsHeaderLoader.vue';
import HotelMainDescriptionSectionLoader from './HotelMainDescriptionSectionLoader.vue';
import HotelSelectionSectionLoader from './HotelSelectionSectionLoader.vue';

const browserStore = useBrowserStore();
</script>

<template>
  <div class="hotel-details-description-section-loader">
    <div class="left-column">
      <HotelDetailsHeaderLoader />
      <HotelDescriptionOpeningParagraphSectionLoader />
      <HotelSelectionSectionLoader v-if="browserStore.isSmallerThan1200px" />
      <PriceGuaranteeSunBanner v-if="browserStore.isSmallerThan1200px" />
      <HotelAmenitiesSectionLoader class="hotel-amenities-section" />
      <HotelMainDescriptionSectionLoader />
    </div>
    <div class="right-column">
      <HotelSelectionSectionLoader v-if="!browserStore.isSmallerThan1200px" />
      <PriceGuaranteeSunBanner v-if="!browserStore.isSmallerThan1200px" />
      <div class="map-loading-container">
        <div class="title">{{ $t('planner.location') }}</div>
        <div class="map-loading" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-details-description-section-loader {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto;
  gap: var(--spacing-16);

  @include for-less-or-equal-than-900-px {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, min-content);
    gap: 0;
  }

  @include for-less-or-equal-than-1200-px {
    padding: var(--spacing-16) var(--spacing-16) 0 var(--spacing-16);
  }

  .left-column {
    grid-column: 1 / span 7;
    padding: var(--spacing-32) 0;

    @include for-less-or-equal-than-900-px {
      grid-column: 1;
    }

    @include for-less-or-equal-than-1200-px {
      padding: 0;
    }

    .hotel-amenities-section {
      margin-bottom: var(--spacing-32);
    }
  }

  .right-column {
    grid-column: 8 / -1;

    padding: var(--spacing-32) 0;

    @include for-less-or-equal-than-900-px {
      grid-column: 1;
    }

    @include for-less-or-equal-than-1200-px {
      padding: 0;
    }

    .map-loading-container {
      width: 100%;
      aspect-ratio: 5/3;
      overflow: hidden;
      position: relative;
      padding-bottom: var(--spacing-16);
      display: flex;
      flex-direction: column;

      @include for-less-or-equal-than-1200-px {
        aspect-ratio: 7/5;
      }

      .title {
        margin: var(--spacing-16) 0;
        color: var(--color-neutral-70);
        @include font-heading-5;
      }

      .map-loading {
        @include animated-background-secondary;
        border-radius: var(--border-radius-12);
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
